export default {"src":"/_next/static/media/CTVA.84c745f5.svg","height":18,"width":18};